import {between, required} from 'vuelidate/lib/validators';
import {IPavementStructureScenarioImperial} from "@/modules/structure/interfaces/pavementStructure";
import {createPerRoadLayerValidations} from "@/modules/perRoad/lib/validations";

export const createStructureValidations = (scenario: IPavementStructureScenarioImperial, page: number) => ({
  scenarioImperial: {
    /*
     Scenario Info
     */
    name: {
      required,
    },

    structureSeasons: (function () {
      const seasonsToValidate = scenario.structureSeasons;
      const seasonList: { [index: number]: any } = {};
      seasonsToValidate.forEach((s, i) => {
        seasonList[i] = {
          duration_weeks: {
            required,
            between: between(0, 52),
          },
          temp_degF: {
            required,
            between: between(-100, 200),
          },
        };
      });
      return seasonList;
    }()),

    /*
     Layers
     */
    structureLayers: (function () {
      const itemsToValidate = scenario.structureLayers;
      const itemList: { [index: number]: any } = {};
      itemsToValidate.forEach((s, i) => {
        itemList[i] = createPerRoadLayerValidations(s, page);
      });
      return itemList;
    }()),
  },


  /*
   Overall page validation
   */
  1: [
    'scenarioImperial.name',
    'scenarioImperial.structureSeasons',
  ],
  2: [],
  3: [],
  4: [],
  5: [
    '1',
    '2',
    '3',
    '4',
  ],
});
